import React from "react";

const Contact = () => {
  return (
    <div className="container py-4" style={{ marginTop: "50px" }}>
      <h2 className="mb-3">Contact - CrickPay</h2>
      <p>
        Need help with CrickPay? Our support team can assist with academy setup,
        player management, payments, attendance, and account access.
      </p>

      <h5 className="mt-4">How Can We Help?</h5>
      <ul>
        <li>Player registration, profiles, and package configuration.</li>
        <li>Coach assignment, attendance, and training session questions.</li>
        <li>Payment, receipt, due date, and subscription support.</li>
        <li>Login, password, and account access assistance.</li>
      </ul>

      <h5 className="mt-4">Before Contacting Support</h5>
      <p>
        Please include your academy name, registered email address, and a short
        description or screenshot of the issue. This helps us resolve your
        request faster.
      </p>

      <h5 className="mt-4">Contact Us</h5>
      <p>For support, email our team at:</p>
      <ul>
        <li>
          Email: <a href="mailto:info@crickpay.net">info@crickpay.net</a>
        </li>
      </ul>
    </div>
  );
};

export default Contact;
